














import axios from 'axios';
import UserModule from '@/store/modules/user';
import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
  @Prop() showUnManageRankPicker: boolean;

  @Prop() value: string;

  @Watch('showUnManageRankPicker', { deep: true, immediate: true })
  async ShowDeptPicker(val: boolean) {
    this.show = val;
  }
  show: boolean = false;
  columns: any = [];
  deptData: any = [];
  onConfirm(val: string) {
    this.$emit('unManRankConfirm', val);
  }
  onCancel() {
    this.$emit('unManRankCancel');
  }

  async getRank() {
    try {
      await apiAxios
        .get('/api/Standard/GetItemFromCode?code=unManageRank', axiosOptions)
        .then(res => {
          if (res) {
            this.columns = res.data.data.sort((a, b) => {
              if (a.name === '无') return -1;
              else if (b.name === '无') return 1;
              else if (a.code === '0' && b.code !== '0') {
                return 1;
              } else if (a.code !== '0' && b.code === '0') {
                return -1;
              } else return a.order - b.order;
            });
            this.$emit(
              'updateView',
              this.columns.find(e => e.order === this.value)
            );
          }
        })
        .catch(err => {});
    } catch (err) {
      console.log('%c [ err ]-373', 'font-size:13px; background:pink; color:#bf2c9f;', err);
    }
  }

  mounted() {
    this.getRank();
  }
}
export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
